export var TLReportsRoutes = {
    "/reports?date&period": {
        "loginRequired": true,
        "name": "appLayout.schedule.reports",
        "type": "frontend",
        "abstract": true,
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./tl-reports.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../../../hmodules/save-views/save-views.module.js");
                }
            },
        ],
        "views": {
            "body": {
                "component": "teamLiveReportsContainer",
            }
        },
        "onEnter": ['hUser', function (hUser) {
            if (!hUser.hasSalesAccess()) {
                hRedirect('/dashboard');
            }
        }]
    },
    "/absence-tracker-report?employeeId": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.absence-tracker-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "absenceTrackerComponent",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Absence tracker report | Harri"
            }
        ],
        "onEnter": ['TeamScheduleService', function (TeamScheduleService) {
            TeamScheduleService.getActiveBrand()
                .then(function (brand) {
                        var isAbsenceTrackerReportVisible = false;

                        AttendanceAPI.getAbsenceTypes(brand.id)
                            .then(function (absenceTypes) {
                                if (absenceTypes && absenceTypes.length) {
                                    for (var i in absenceTypes) {
                                        if (['CUSTOM', 'PATERNITY', 'BEREAVEMENT', 'MATERNITY', 'SHARED_PARENTAL', 'ADOPTION', 'HOLIDAY', 'LOA', 'TIME_OFF'].indexOf(absenceTypes[i].type) > -1) {
                                            isAbsenceTrackerReportVisible = true;
                                            break;
                                        }
                                    }
                                }
                                if (!isAbsenceTrackerReportVisible) {
                                    hRedirect('/404');
                                }
                            })
                            .catch(function (error) {
                                hRedirect('/404');
                                console.error(error)
                            })
                });
        }]
    },
    "/enterprise-flash-report": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.enterprise-flash-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "enterpriseFlashDashReportComponent",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Flash Dash Report | Harri"
            }
        ]
    },
    "/flash-report-v2": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.flash-report-v2",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "flashDashReportV2Component",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["reporting"]
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Flash Report V2 | Harri"
            }
        ]
    },
    "/punch-detail-report": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.punch-detail-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "punchDetailReportComponent",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Punch Detail Report | Harri"
            }
        ],
    },
    "/punch-reports?reportType&dateType&clockType&punchType&punchStatus&adjustmentType": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.punch-reports",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "mcdPunchReportsContainer",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "params": {
            reportType: {
                dynamic: true
            },
            dateType: {
                dynamic: true
            },
            clockType: {
                dynamic: true
            },
            punchType: {
                dynamic: true
            },
            punchStatus: {
                dynamic: true
            },
            adjustmentType: {
                dynamic: true
            },
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Punch Reports | Harri"
            }
        ]
    },
    "/employee-labor-variance-report": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.employee-labor-variance-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "rtEmployeeLaborComponent"
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Employee Labor Variance Report | Harri"
            }
        ]
    },
    "/logbook-entries-report": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.logbook-entries-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "logbookEntriesReportComponent",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Logbook Entries Report | Harri"
            }
        ]
    },
    "/logbook-tasks-report": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.logbook-tasks-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "logbookTasksReportComponent",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Logbook Tasks Report | Harri"
            }
        ]
    },
    "/schedule-change-report": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.schedule-change-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "scheduleChangeReportComponent",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Schedule Change Report | Harri"
            }
        ]
    },
    "/regular-schedule-variation-report": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.regular-schedule-variation-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "regularScheduleVariationReportComponent",
            }
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Regular Schedule Variation Report | Harri"
            }
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['reports'],
        }
    },
    "/daily-crew-schedule-report?date&view_type&include_kpis&auto_print&orientation&daily_known_as": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.daily-crew-schedule-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "dailyCrewScheduleReportComponent",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "params": {
            date: {dynamic: true},
            view_type: {dynamic: true},
            include_kpis: {dynamic: true},
            auto_print: {dynamic: true},
            orientation: {dynamic: true},
            daily_known_as: {dynamic: true},
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Daily Crew Schedule Report | Harri"
            }
        ]
    },
    "/logbook-checklists-report": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.logbook-checklists-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "logbookTasksReportComponent",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Logbook CheckLists Report | Harri"
            }
        ]
    },
    "/forecast-accuracy-report": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.forecast-accuracy-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "forecastAccuracyReportComponent",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "route_dependencies": [
            {path: "d3", type: "library", "name": "d3"},
            {path: "c3", type: "library", "name": "c3"}
        ],
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Forecast Accuracy Report | Harri"
            }
        ]
    },
    "/detailed-employee-labor-report": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.detailed-employee-labor-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "detailedEmployeeLaborReportComponent",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['reports'],
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Detailed Employee Labor Report | Harri"
            }
        ]
    },
    "/no-pay-report": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.no-pay-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "noPayReportComponent",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['reports'],
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "No Pay Report | Harri"
            }
        ]
    },
    "/engagement-ratings-report": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.engagement-ratings-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "pollEventsReportComponent",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Engagement Ratings Report | Harri"
            }
        ]
    },
    "/labor-variance-report": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.labor-variance-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "laborVarianceReportComponent"
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Labor Variance Report | Harri"
            }
        ]
    },
    "/engagement-non-ratings-report": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.engagement-non-ratings-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "onboardingJourneyEventsComponent",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['reports'],
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Engagement Non-Ratings Report | Harri"
            }
        ]
    },
    "/schedule-audit-report": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.schedule-audit-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "scheduleAuditReportComponent"
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Schedule Audit Report | Harri"
            }
        ]
    },
    "/missed-breaks": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.missed-breaks",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "rtMissedBreaksComponent"
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Missed Breaks Report | Harri"
            }
        ]
    },
    "/overtime-report": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.overtime-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "rtOvertimeComponent"
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Overtime report | Harri"
            }
        ]
    },
    "/premium-report": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.premium-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "schedulePremiumChangesReportComponent",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "FWW Premiums Report | Harri"
            }
        ]
    },
    "/scheduling-status-report": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.scheduling-status",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "schedulingStatusComponent"
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['reports'],
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Scheduling Status Report | Harri"
            }
        ]
    },
    "/schedule-creation-metric-report": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.schedule-creation-metric",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "scheduleCreationMetricReportComponent"
            }
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Schedule Creation Metric Report | Harri"
            }
        ]
    },
    "/employee-edits-report": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.employee-edits-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "employeeEditsReportComponent",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Employee Edits Report | Harri"
            }
        ]
    },
    "/adp-employee-sync-status-report": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.adp-employee-sync-status-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "adpEmployeeSyncStatusReportComponent",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["save_views"]
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "ADP Employee Sync Status Report | Harri"
            }
        ]
    },
    "/available-shifts": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.available-shifts",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "tlUnassignedPublishedShiftsReportComponent"
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Available Shifts Report | Harri"
            }
        ]
    },
    "/holiday-allowance": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.holiday-allowance",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "holidayAllowanceReportComponent"
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Holiday Allowance Report | Harri"
            }
        ]
    },
    "/availability": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.availability",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "availabilityReportComponent"
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Availability Report | Harri"
            }
        ]
    },
    "/labor-analysis-report": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.labor-analysis-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "laborAnalysisReportComponent",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Labor Analysis Report | Harri"
            }
        ],
        "route_dependencies": [
            {path: "d3", type: "library", "name": "d3"},
            {path: "c3", type: "library", "name": "c3"}
        ]
    },
    "/wage-type-summary-report": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.wage-type-summary-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "wageTypeSummaryReportComponent",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Wage Type Summary Report | Harri"
            }
        ],
        "onEnter": ['TeamScheduleService', function (TeamScheduleService) {
        }]
    },
    "/employee-roster": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.employee-roster",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "employeeRosterReportComponent"
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Employee Roster Report | Harri"
            }
        ]
    },
    "/scheduled-breaks-report?breakResolution&scheduleBreaksPremiumOwed&locationId": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.scheduled-breaks-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "scheduledBreaksReportComponent",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "params": {
            breakResolution: {
                dynamic: true,
            },
            scheduleBreaksPremiumOwed: {
                dynamic: true,
            },
            locationId: {
                dynamic: true,
            }
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Breaks Report | Harri"
            }
        ],
        "onEnter": ['TeamScheduleService', function (TeamScheduleService) {
        }]
    },
    "/pay-period-report": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.pay-period-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "payPeriodReportComponent",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Pay Period Report | Harri"
            }
        ]
    },
    "/daily-activity-report?dateSelected&timePeriod": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.daily-activity-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "dailyActivityReportComponent",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "params": {
            dateSelected: {
                dynamic: true,
            },
            timePeriod: {
                dynamic: true,
            }
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Daily Activity Report | Harri"
            }
        ],
        "route_dependencies": [
            {path: "d3", type: "library", "name": "d3"},
            {path: "c3", type: "library", "name": "c3"}
        ]
    },
    "/needed-hours-report?dateSelected&limitRunningTotal&timePeriod": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.needed-hours-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "neededHoursReportComponent",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "params": {
            dateSelected: {
                dynamic: true,
            },
            limitRunningTotal: {
                dynamic: true,
            },
            timePeriod: {
                dynamic: true,
            }
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Needed Hours Report | Harri"
            }
        ],
        "route_dependencies": [
            {path: "d3", type: "library", "name": "d3"},
            {path: "c3", type: "library", "name": "c3"}
        ]
    },
    "/weekly-schedule-report?show_total_hours&user_ids&orientation&auto_print&show_gfe_status&gfe_status&known_as": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.weekly-schedule-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "weeklyScheduleReportComponent",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "params": {
            show_total_hours: {dynamic: true},
            user_ids: {dynamic: true},
            orientation: {dynamic: true},
            auto_print: {dynamic: true},
            show_gfe_status: {dynamic: true},
            gfe_status: {dynamic: true},
            known_as: {dynamic: true},
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Weekly Schedule Report | Harri"
            }
        ]
    },
    "/labor-exception-report?exceptedExceptionNameCodes&ageGroupAtExceptionCodes&timecardStatusCodes&exceptionStatusCodes": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.labor-exception-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "laborExceptionReportComponent",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "params": {
            exceptedExceptionNameCodes: {
                dynamic: true
            },
            ageGroupAtExceptionCodes: {
                dynamic: true
            },
            timecardStatusCodes: {
                dynamic: true
            },
            exceptionStatusCodes: {
                dynamic: true
            },
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Labor Exception Report | Harri"
            }
        ]
    },
    "/team-member-master-report": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.team-member-master-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "teamMemberMasterReportComponent",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["save_views"]
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Team Member Master Report | Harri"
            }
        ]
    },
    "/turnover-report": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.turnover-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "turnOverReportComponent",
            }
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Employee Turnover Report | Harri"
            }
        ],
        "route_dependencies": [
            {path: "d3", type: "library", "name": "d3"},
            {path: "c3", type: "library", "name": "c3"}
        ]
    },
    "/consent-report": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.consent-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "consentReportComponentOptions",
            }
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Consent Report | Harri"
            }
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['reports'],
        },
    },
    "/time-sheets-report": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.time-sheet-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "timeSheetReportComponent",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["save_views"]
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Timesheet Report | Harri"
            }
        ]
    },
    "/clock-in-message-report": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.clock-in-message-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "clockInMessageReportComponent",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Timesheet Report | Harri"
            }
        ],
        "route_dependencies": [
            {path: "d3", type: "library", "name": "d3"},
            {path: "c3", type: "library", "name": "c3"}
        ]
    },
    "/gfe-documents-tracking-report": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.gfe-documents-tracking-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "gfeDocumentsTrackingReportComponent",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "GFE Documents Tracking Report | Harri"
            }
        ],
    },
    "/attendance-reliability-report": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.attendance-reliability-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "attendanceReliabilityReportComponent",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Attendance Reliability Report| Harri"
            }
        ],
    },
    "/integration-rejection-report": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.integration-rejection-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "integrationRejectionReportComponent",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Integration Rejection Report Component| Harri"
            }
        ],
    },
    "/employee-detailed-satisfaction": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.employee-detailed-satisfaction-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "employeeDetailedSatisfactionComponent",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Employee Detailed Satisfaction Report | Harri"
            }
        ],
        "onEnter": ['TeamScheduleService', function (TeamScheduleService) {
            TeamScheduleService.getActiveBrand()
                .then(function (brand) {
                    if (brand.type !== 'ENTERPRISE') {
                        hRedirect('/schedule');
                    }
                });
        }]
    },
    "/manager-schedule-report?from_date&to_date&auto_print&orientation": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.manager-schedule-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "managerScheduleReportComponent",
            }
        },
        "params": {
            from_date: {dynamic: true},
            to_date: {dynamic: true},
            auto_print: {dynamic: true},
            orientation: {dynamic: true},
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['reports'],
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Manager Schedule Report | Harri"
            }
        ],
    },
    "/unscheduled-employee-report": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.unscheduled-employee-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "unscheduledEmployeeComponent",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['reports'],
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Unscheduled Employee Report | Harri"
            }
        ],
    },
    "/unemployment-claims-report": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.unemployment-claims-report",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "unemploymentClaimsReportComponent",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['reports'],
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Unemployment Claims Report | Harri"
            }
        ],
    },
    "/redirect-to-reports": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.reports.redirect-to-reports",
        "type": "frontend",
        "views": {
            "reports-body": {
                "component": "redirectToTlReportsComponent",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['reports'],
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Redirecting... | Harri"
            }
        ],
    }
};
